<nav class="bottom-navigation" aria-label="Bund navigation" role="navigation">
    <!-- axe-linter-disable-next-line -->
    <ul class="bottom-navigation__list" role="list">
        @for (item of menuItems; track item) {
        <li class="bottom-navigation__item" role="listitem">
            <a class="bottom-navigation__link" [routerLink]="item.route" routerLinkActive="bottom-navigation__link--active">
                <mat-icon class="bottom-navigation__icon" [svgIcon]="item.icon" aria-hidden="true"></mat-icon>
                <span class="bottom-navigation__label">{{ item.label }}</span>
            </a>
        </li>
        }
    </ul>
</nav>
